/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  GamoraController,
  GamoraControllerAbortContextInput,
  GamoraControllerContextIdentifier,
  GamoraFoundationNodeArgs,
  GamoraUUIDGuard,
  assert,
  debugCreate,
} from '@ver.id/libs.internal.gamora';
import {
  HoruzProtocolChulakServiceStateContext,
  HoruzProtocolChulakServiceStateContextRegistry,
} from './states/context.js';
import {
  HoruzProtocolChulakServiceStateMap,
  HoruzProtocolChulakServiceTransitionMap,
} from './statemap.js';
import { HoruzProtocolChulakServiceStateAbort } from './states/service/abort.state.js';
import { HoruzProtocolChulakServiceStateAgentStart } from './states/service/agent-start.state.js';
import { HoruzProtocolChulakServiceStateAppPairing } from './states/service/app-pairing.state.js';
import { HoruzProtocolChulakServiceStateAppPresentation } from './states/service/app-presentation.state.js';
import { HoruzProtocolChulakServiceStateDone } from './states/service/done.state.js';
import { HoruzProtocolChulakServiceStateStopped } from './states/service/stopped.state.js';
import { IHoruz } from '../../horuz.js';
const debug = debugCreate({ namespace: 'horuz:protocols:chulak:service' });

/**
 * @internal
 */
export type HoruzProtocolChulakServiceControllerArgs<TRoot extends IHoruz> =
  GamoraFoundationNodeArgs<typeof HoruzProtocolChulakServiceStateMap>;

/**
 * HoruzProtocolChulakServiceController
 * @public
 */
export class HoruzProtocolChulakServiceController<
  TRoot extends IHoruz,
> extends GamoraController<
  typeof HoruzProtocolChulakServiceStateMap,
  HoruzProtocolChulakServiceStateContext,
  TRoot
> {
  constructor(args: HoruzProtocolChulakServiceControllerArgs<TRoot>) {
    assert(
      typeof args === 'object' && args !== null,
      'Invalid args argument: not an object.',
    );

    // Initialize base
    super({
      ...args,
      stateMap: {
        // Used states
        Done: [HoruzProtocolChulakServiceStateDone, {}],
        Abort: [HoruzProtocolChulakServiceStateAbort, {}],
        AppPairing: [HoruzProtocolChulakServiceStateAppPairing, {}],
        AgentStart: [HoruzProtocolChulakServiceStateAgentStart, {}],
        AppPresentation: [HoruzProtocolChulakServiceStateAppPresentation, {}],
        Stopped: [HoruzProtocolChulakServiceStateStopped, {}],
      },
      transitionMap: HoruzProtocolChulakServiceTransitionMap,
    });
  }

  /**
   * Gets adapter
   */
  get serviceSessionStore() {
    return this.$root.$('protocols').$('chulak').$('store').$('serviceSession');
  }

  /**
   * Creates context registry
   */
  createContextRegistry(
    serverSessionUuid: GamoraUUIDGuard,
    serviceSessionUuid: GamoraUUIDGuard,
  ): HoruzProtocolChulakServiceStateContextRegistry {
    return {
      serverSessionUuid,
      serviceSessionUuid,
    };
  }
}
